var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { styled } from 'styled-components';
import { useToggle } from '@hn-front/utils';
import { LinkButton } from '@hn-ui/buttons';
import { Spinner, Download } from '@hn-ui/icons';
import { BlueLink } from '@hn-ui/links';
import { Tooltip } from '@hn-ui/tooltips';
import { ParentReportEvents, useParentReportAnalytics, } from '../hooks/useParentReportAnalytics';
var Controls = styled.div.withConfig({ displayName: "Controls", componentId: "sc-2mlmzr" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 24px;\n  justify-self: flex-end;\n  align-items: center;\n"], ["\n  display: flex;\n  gap: 24px;\n  justify-self: flex-end;\n  align-items: center;\n"])));
var Text = styled.p.withConfig({ displayName: "Text", componentId: "sc-a5sq1s" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n"])));
var downloadEvents = {
    en: ParentReportEvents.downloadEnglishReportClick,
    es: ParentReportEvents.downloadSpanishReportClick,
};
var requestEvents = {
    en: ParentReportEvents.requestEnglishReportClick,
    es: ParentReportEvents.requestSpanishReportClick,
};
var Buttons = function (_a) {
    var groupId = _a.groupId, status = _a.status, language = _a.language, apiUrl = _a.apiUrl, onReportRequest = _a.onReportRequest, rest = __rest(_a, ["groupId", "status", "language", "apiUrl", "onReportRequest"]);
    var _b = useToggle(), isToggledRequest = _b.isToggled, toggleRequest = _b.toggle;
    var showRequest = status === 'pending' && !isToggledRequest;
    var showBusy = status === 'busy' || isToggledRequest;
    var showDownload = status === 'completed' && !isToggledRequest && apiUrl;
    var sendGaEvent = useParentReportAnalytics();
    var onDownloadPdf = useCallback(function () {
        var _a;
        var eventName = (_a = downloadEvents[language]) !== null && _a !== void 0 ? _a : downloadEvents.en;
        sendGaEvent(eventName);
    }, [sendGaEvent]);
    var handleOnGenerateReport = useCallback(function () {
        toggleRequest();
        onReportRequest === null || onReportRequest === void 0 ? void 0 : onReportRequest();
        fetch("/api/teachers/reports/groups/" + groupId, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data: {
                    language: language,
                    report_type: 'parent_report',
                },
            }),
        })
            .then(function () {
            var _a;
            var eventName = (_a = requestEvents[language]) !== null && _a !== void 0 ? _a : requestEvents.en;
            sendGaEvent(eventName);
        })
            .catch(function () { return toggleRequest(); });
    }, [sendGaEvent, groupId, language, onReportRequest, toggleRequest]);
    return (_jsxs(Controls, __assign({}, rest, { children: [showBusy && (_jsx(Tooltip, __assign({ content: 'Report generation in progress. Refresh the page in a couple of minutes to access the file.', maxWidth: '416px' }, { children: _jsxs(Text, { children: [_jsx(Spinner, { disabled: true, size: 20 }, void 0), "Pending (Refresh required)"] }, void 0) }), void 0)), showRequest && (_jsx(LinkButton, __assign({ fit: true, onClick: handleOnGenerateReport }, { children: "Request Report" }), void 0)), showDownload && (_jsxs(_Fragment, { children: [_jsx(Tooltip, __assign({ content: 'Upon clicking this button, your browser will initiate the download of a PDF file.', maxWidth: '320px' }, { children: _jsxs(BlueLink, __assign({ bold: true, href: apiUrl, onClick: onDownloadPdf }, { children: [_jsx(Download, {}, void 0), "Download"] }), void 0) }), void 0), _jsx(LinkButton, __assign({ fit: true, onClick: handleOnGenerateReport }, { children: "Update Report" }), void 0)] }, void 0))] }), void 0));
};
export { Buttons };
var templateObject_1, templateObject_2;
